import React from 'react'
import { connect } from 'react-redux'

import Button from '../components/Button'

import PageHeader from '../components/PageHeader'
import PageSection from '../components/PageSection'
import WordpressImage from '../components/WordpressImage'
import GenericCtaModule from '../components/GenericCtaModule'

import EnterpriseContactModal from '../components/EnterpriseContactModal'
import VerticalsCarousel from '../components/VerticalsCarousel'
import TestimonialsCarousel from '../components/TestimonialsCarousel'
import CustomVoiceInterfaces from '../components/CustomVoiceInterfaces'

import { showModal } from '../../reducers/modal'

import { trackEvent } from '../../utils/tracking'

const productFeatures = [
  {
    title: 'Real-Time Performance',
    subtitle:
      'Our low-latency voice interfaces perform as well or better than the market leaders.',
    icon: 'speed-dial'
  },
  {
    title: 'Customizable Experience',
    subtitle:
      'From custom wake words to a personalized language model per each end user through our API.',
    icon: 'switches'
  },
  {
    title: 'Offline and Local',
    subtitle:
      'No internet connection required, ensuring your voice assistant won’t depend on signal strength.',
    icon: 'offline'
  },
  {
    title: 'Built-In Compliance',
    subtitle:
      "Snips doesn't use the cloud, guaranteeing compliance with the strictest data regulations.",
    icon: 'eu-stars'
  }
]
const WPindustrySolutionsSectionTitle = 'Tailored for your business'

function ProductFeatures ({ features }) {
  return (
    <ul className='enterprise-page__product__features col-10 sm-col-9 mx-auto center'>
      {productFeatures.map(({ title, subtitle, icon }) => {
        return (
          <li key={title} className='mb3'>
            <img
              className='mb2'
              src={`/static/images/icons/${icon}.svg`}
              alt='badge icon'
            />
            <h3 className='larger mb2'>{title}</h3>
            <p className='text-para very-small maxw-mini mx-auto'>{subtitle}</p>
          </li>
        )
      })}
    </ul>
  )
}

export const EnterprisePage = ({
  data: {
    acf: {
      headerTitle,
      headerSubtitle,
      headerBtnLabel,

      industrySolutionsVerticalsCarousel,
      industrySolutionsPartners,

      testimonialSlides,

      partnersSectionTitle,
      partnersSectionData2018,

      bottomCtaTitle,
      bottomCtaSubtitle,
      bottomCtaButtonLabel
    }
  },
  showModal
}) => {
  return (
    <main className='enterprise-page main maxw-xxlarge mx-auto px2'>
      <PageHeader
        title={
          <span className='page-header__title mb2'>
            Snips.<br className='xs-show' /> Let’s&nbsp;talk.
          </span>
        }
        extraClass='enterprise-page__page-header'
      >
        <p className='col-10 md-col-8 lg-col-6 text-para mx-auto mb3'>
          {headerSubtitle}
        </p>
        {headerBtnLabel && (
          <Button
            className='button button--large button--primary-alt mb3'
            onClick={() => {
              trackEvent('EnterpriseContactModal', 'EnterpriseHeroSection')
              showModal(<EnterpriseContactModal />)
            }}
          >
            {headerBtnLabel}
          </Button>
        )}
      </PageHeader>

      <PageSection extraClass='enterprise-page__industry-solutions page-section--small bg-primary center'>
        <h2 className='h2 mb2 white'>{WPindustrySolutionsSectionTitle}</h2>
        <VerticalsCarousel
          extraClass='mb3'
          slides={industrySolutionsVerticalsCarousel}
        />
        {industrySolutionsPartners &&
          industrySolutionsPartners.length > 0 && (
            <div className='enterprise-page__industry-solutions__partners mx-auto flex flex-wrap justify-around items-center'>
              {industrySolutionsPartners.map(({ image, label }, idx) => (
                <img
                  className='enterprise-page__industry-solutions__partners__logo mx3 mb3'
                  key={idx}
                  src={image.url}
                  alt={label}
                />
              ))}
            </div>
          )}
      </PageSection>

      <PageSection extraClass='enterprise-page__product bg-white center'>
        <h2 className='h3 mb4 maxw-medium mx-auto'>
          Your&nbsp;Products.<br className='xs-show' /> Your&nbsp;Customers.<br />Your&nbsp;Interface.
        </h2>
        <ProductFeatures features={productFeatures} />
      </PageSection>

      <CustomVoiceInterfaces />

      {testimonialSlides && (
        <PageSection extraClass='enterprise-page__partners-section page-section--tiny bg-white text-color mb2'>
          <div className='col-11 mx-auto center'>
            <TestimonialsCarousel
              extraClass='lg-col-8 mx-auto enterprise-page__partners-section__testimonials__carousel overflow-hidden mb4'
              slides={testimonialSlides}
            />

            {partnersSectionData2018 &&
              partnersSectionData2018.length > 0 && (
                <section className='enterprise-page__partners-section__brands mb4 pt4 pb3'>
                  {partnersSectionTitle && (
                    <h2 className='center mb4 h2'>{partnersSectionTitle}</h2>
                  )}
                  <div className='maxw-large mx-auto flex flex-wrap justify-center items-center'>
                    {partnersSectionData2018.map(({ image, label }, idx) => (
                      <div className='flex-none p2 col-6 lg-col-4 mb2'>
                        <WordpressImage
                          className='enterprise-page__partners-section__brands__logo'
                          key={idx}
                          img={image}
                          alt={label}
                        />
                      </div>
                    ))}
                  </div>
                </section>
              )}
          </div>
        </PageSection>
      )}

      <PageSection extraClass='overflow-hidden bg-white top-rounded bottom-rounded'>
        <GenericCtaModule
          headerTitle={bottomCtaTitle}
          subtitle={bottomCtaSubtitle}
          // temporary static image - should be animated
          imageUrl='/static/images/weather-guy.svg'
          buttonLabel={bottomCtaButtonLabel}
          buttonClass='button--primary-alt'
          buttonHref={null}
          buttonOnClick={e => {
            e.preventDefault()
            trackEvent(
              'EnterpriseContactModal',
              'EnterprisePageBottomCTASection'
            )
            showModal(<EnterpriseContactModal />)
          }}
          buttonForceAnchorElement={false}
          secondaryEnterpriseButton={false}
        />
      </PageSection>
    </main>
  )
}

export default connect(null, { showModal })(EnterprisePage)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/EnterprisePage.js